// ----------------------------------------------------------------------

export default function Timeline(theme) {
  return {
    MuiClockNumber: {
      styleOverrides: {
        root: {
          color: 'black'
        }
      }
    },
    MuiTimelineDot: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        }
      }
    },

    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider
        }
      }
    }
  };
}
